import { render, staticRenderFns } from "./reportcomp.vue?vue&type=template&id=754bbaf4&scoped=true&"
import script from "./reportcomp.vue?vue&type=script&lang=js&"
export * from "./reportcomp.vue?vue&type=script&lang=js&"
import style0 from "./reportcomp.vue?vue&type=style&index=0&id=754bbaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754bbaf4",
  null
  
)

export default component.exports